export default "__VITE_ASSET__6a992d92__"